import { InteractionProperty, InteractionPropertyType } from "./InteractionProperty";

export const requiredGlobalQuizProperties: InteractionProperty[] = [
  {
    name: "Can Hide",
    id: "canHide",
    type: InteractionPropertyType.boolean,
    value: false,
  },
];